import React, { Component, PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import dates from 'utils/dates';

import './CarHireOptionsHeader.desktop.scss';
import './CarHireOptionsHeader.mobile.scss';

export default class CarHireOptionsHeader extends Component {
  static propTypes = {
    firstCarHireOption: ImmutablePropTypes.mapContains({
      dropoffDate: PropTypes.string.isRequired,
      dropoffTime: PropTypes.string.isRequired,
      pickupDate: PropTypes.string.isRequired,
      pickupTime: PropTypes.string.isRequired,
    }).isRequired,
  };

  render() {
    const { firstCarHireOption } = this.props;

    const dateFormat = 'ddd D MMM YYYY';
    const pickupDate = dates.format(dates.isoStringToDate(firstCarHireOption.get('pickupDate')), dateFormat);
    const dropoffDate = dates.format(dates.isoStringToDate(firstCarHireOption.get('dropoffDate')), dateFormat);

    return (
      <div className="car-hire-options-header">
        <div className="car-hire-options-header__dates">
          <div className="car-hire-options-header__date" data-item="pickup">Pick up: { pickupDate } - { firstCarHireOption.get('pickupTime') }</div>
          <div className="car-hire-options-header__date" data-item="dropoff">Drop off: { dropoffDate } - { firstCarHireOption.get('dropoffTime') }</div>
        </div>
        <div className="car-hire-options-header__age-info">
          The main driver must be at least 25 years old
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/CarHire/CarHireOptionsHeader.jsx
 **/